// extracted by mini-css-extract-plugin
export default {"container":"tW-z","topReviewHeading":"uW-z","criticalReview":"vW-z","favorableReview":"wW-z","vsSeparator":"xW-z"};